module.exports = __webpack_public_path__ + "static/media/safari.c2c2cfb1.png";